<template>
  <el-alert
    class="purchase-scope-rules"
    type="info"
    :closable="false"
    show-icon
  >
    <template slot="title">
      购买范围判定规则
      <span class="rules-tip">不选 = 不限制，所有学员均可购买</span>
    </template>

    <span class="rule-list">
      <span
        v-for="rule in rules"
        :key="rule.value"
        class="rule-item"
        :class="{ 'is-active': Number(scope) === rule.value }"
      >
        <span class="rule-name">{{ rule.name }}</span>
        <span class="rule-desc">{{ rule.desc }}</span>
      </span>

      <span class="rule-relation">
        关系：「仅限新人」属于「仅限未持卡学员」；「仅限持卡学员」与「仅限未持卡学员」互补。
      </span>
    </span>
  </el-alert>
</template>

<script>
export default {
  name: 'VPurchaseScopeRules',
  props: {
    scope: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    // 展示顺序：1 新人 → 3 未持卡 → 2 持卡；1 是 3 的子集，3 是 2 的反面
    rules: [
      {
        value: 1,
        name: '仅限新人',
        desc: '名下没有非私教课卡（私教课卡不算）、没有非录入错误的非私教退卡记录、没有把非私教课卡转给别人的记录、没有课次券；没有已签到/已爽约的非私教课预约。',
      },
      {
        value: 3,
        name: '仅限未持卡学员',
        desc: '当前没有非私教课卡，也没有非私教课卡的非录入错误退卡记录，也没有把非私教课卡转给别人的记录；可以有课次券、预约记录或私教课卡，仍属于潜在办卡学员。',
      },
      {
        value: 2,
        name: '仅限持卡学员',
        desc: '当前名下有非私教课卡，或曾有非私教课卡的非录入错误退卡记录，或曾把非私教课卡转给其他学员；私教课卡、课次券不算。',
      },
    ],
  }),
};
</script>

<style scoped>
.purchase-scope-rules {
  width: 100%;
  box-sizing: border-box;
}

.rules-tip {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #606266;
}

.rule-list {
  display: block;
  margin-top: 4px;
}

.rule-item {
  display: flex;
  gap: 8px;
  padding: 3px 6px;
  border-left: 2px solid transparent;
  border-radius: 3px;
  font-size: 12px;
  line-height: 1.7;
  color: #606266;
}

.rule-item + .rule-item {
  margin-top: 2px;
}

.rule-item.is-active {
  background: #ecf5ff;
  border-left-color: #409eff;
  color: #303133;
}

.rule-name {
  flex: 0 0 96px;
  font-weight: 600;
  color: #303133;
}

.rule-desc {
  flex: 1;
  min-width: 0;
}

/* 三条规则读完后再说关系，避免「上述 / 与下方相反」这种前后引用 */
.rule-relation {
  display: block;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #dcdfe6;
  font-size: 12px;
  line-height: 1.6;
  color: #606266;
}
</style>
